import React from 'react';
import { FriendRequest, FriendshipTier } from '../types/friends';
import { PendingRequestCard } from './PendingRequestCard';

interface PendingRequestsProps {
  incomingRequests: FriendRequest[];
  outgoingRequests: FriendRequest[];
  onRespond: (
    requestId: string, 
    action: 'accept' | 'accept_lower' | 'reject' | 'request_higher',
    tier?: FriendshipTier,
    note?: string
  ) => Promise<void>;
}

export const PendingRequests: React.FC<PendingRequestsProps> = ({ 
  incomingRequests, 
  outgoingRequests, 
  onRespond 
}) => {
  if (incomingRequests.length === 0 && outgoingRequests.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200 border-dashed">
        <p className="text-gray-500">There are no pending requests.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6 mb-8">
      {incomingRequests.length > 0 && (
        <div>
          <h2 className="text-lg font-medium text-gray-900 mb-4">Pending Requests</h2>
          <div className="space-y-3">
            {incomingRequests.map((req) => (
              <PendingRequestCard 
                key={req.id} 
                request={req} 
                isIncoming={true} 
                onRespond={onRespond} 
              />
            ))}
          </div>
        </div>
      )}

      {outgoingRequests.length > 0 && (
        <div>
          <h2 className="text-lg font-medium text-gray-900 mb-4">Sent Requests</h2>
          <div className="space-y-3">
            {outgoingRequests.map((req) => (
              <PendingRequestCard 
                key={req.id} 
                request={req} 
                isIncoming={false} 
                onRespond={onRespond} 
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

